// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { seekerPreferences as fetch } from 'app/redux/modules/seekers';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ChatTextBox from '../thread/text-box';

@connect(() => ({}), { fetch })
@i18n
class SendMessageDialog extends Component {
  i18n;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      data: null,
      reason: ''
    };
  }

  componentDidMount() {
    if (this.props.open === true && !this.state.open) {
      this.handleOpen();
    }
  }

  handleOpen = () => {
    this.setState({ open: true, loading: true });
    this.props
      .fetch(this.props.id)
      .then((result) => {
        this.setState({ loading: false, data: result.payload.result });
      })
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        this.setState({ loading: false, data: null });
      });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      this.setState({ open: false, loading: false, data: null });
    }
  };

  renderDialog() {
    const {
      fullScreen,
      user,
      uuid,
      seekerName,
      seekerId,
      seekerEmail,
      admin
    } = this.props;
    const { open } = this.state;

    return (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={this.handleClose}
      >
        <DialogTitle>
          {this.props.i18n('Send message')}{' '}
          {this.props.i18n('to') + ` ${seekerName} - ${seekerEmail}`}
        </DialogTitle>
        <DialogContent>
          <ChatTextBox
            size={10}
            i18n={this.props.i18n}
            admin={admin}
            afterClick={this.handleClose}
            variables={{
              userId: user ? user.id : null,
              agentUnique: `rentals-${uuid}`,
              seekerName,
              seekerEmail,
              seekerId: String(seekerId)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            flat
            label={this.props.i18n('Close')}
            onClick={this.handleClose}
          />
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { label, icon } = this.props;
    return this.props.open === true ? (
      this.renderDialog()
    ) : (
      <div style={{ display: 'inline-block' }}>
        <Button flat label={label} icon={icon} onClick={this.handleOpen} />
        {this.renderDialog()}
      </div>
    );
  }
}

function SendMessageDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <SendMessageDialog {...props} fullScreen={fullScreen} />;
}

export default SendMessageDialogWithMobileDialog;